import { createAccommodationsQuery } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useAccommodationsQuery = createAccommodationsQuery(HTTP_CONFIG.API.Consumer.url)
